import get from 'lodash/get'

export const isDenied = (user: any,requiredRoles?:any) => {
    const role = get(user, ['profile', 'role'], false)
    if (!role) return true
    return Array.isArray(role)
      ? !role.some((r) => requiredRoles.includes(r))
      : !requiredRoles.includes(role)
  }